import { getProjectState } from '@starflow/app/store';

export const getSelectionRange = () => {
  const { selection, elements } = getProjectState();
  let [maxX, maxY, minX, minY] = [-Infinity, -Infinity, Infinity, Infinity];
  selection.forEach((id) => {
    const aimElement = elements.find((ele) => ele.id === id);
    if (aimElement) {
      minX = Math.min(aimElement.x, minX);
      minY = Math.min(aimElement.y, minY);
      maxX = Math.max(maxX, aimElement.x + aimElement.width * aimElement.scaleX);
      maxY = Math.max(maxY, aimElement.y + aimElement.height * aimElement.scaleY);
    }
  });
  return { maxX, maxY, minX, minY };
};

// export const getSelectionRange = () => {
//   const { selection, elements } = getProjectState();
//   let [maxX, maxY, minX, minY] = [-Infinity, -Infinity, Infinity, Infinity];
//   selection.forEach((id) => {
//     const aimElement = elements.find((ele) => ele.id === id);
//     const { x, y, scaleX, scaleY, rotation, width, height } = aimElement;
//     if (aimElement) {
//       const [centerX, centerY] = [(x + width * scaleX) / 2, (y + height * scaleY) / 2];
//       const rotationRad = (rotation / 180) * Math.PI;
//       const topLeft = { x: (width * scaleX) / 2, y: (height * scaleY) / 2 };
//       const bottomLeft = { x: (width * scaleX) / 2, y: (-height * scaleY) / 2 };
//       const topRight = { x: (-width * scaleX) / 2, y: (height * scaleY) / 2 };
//       const bottomRight = { x: (-width * scaleX) / 2, y: (-height * scaleY) / 2 };

//       const topLeftNew = {
//         x: centerX + topLeft.x * Math.cos(rotationRad) + topLeft.y * Math.sin(rotationRad),
//         y: centerY - topLeft.x * Math.sin(rotationRad) + topLeft.y * Math.cos(rotationRad),
//       };
//       const bottomLeftNew = {
//         x: centerX + bottomLeft.x * Math.cos(rotationRad) + bottomLeft.y * Math.sin(rotationRad),
//         y: centerY - bottomLeft.x * Math.sin(rotationRad) + bottomLeft.y * Math.cos(rotationRad),
//       };
//       const topRightNew = {
//         x: centerX + topRight.x * Math.cos(rotationRad) + topRight.y * Math.sin(rotationRad),
//         y: centerY - topRight.x * Math.sin(rotationRad) + topRight.y * Math.cos(rotationRad),
//       };
//       const bottomRightNew = {
//         x: centerX + bottomRight.x * Math.cos(rotationRad) + bottomRight.y * Math.sin(rotationRad),
//         y: centerY - bottomRight.x * Math.sin(rotationRad) + bottomRight.y * Math.cos(rotationRad),
//       };

//       minX = Math.min(topLeftNew.x, bottomLeftNew.x, topRightNew.x, bottomRightNew.x, minX);
//       minY = Math.min(topLeftNew.y, bottomLeftNew.y, topRightNew.y, bottomRightNew.y, minY);
//       maxX = Math.max(maxX, topLeftNew.x, bottomLeftNew.x, topRightNew.x, bottomRightNew.x);
//       maxY = Math.max(maxY, topLeftNew.y, bottomLeftNew.y, topRightNew.y, bottomRightNew.y);
//     }
//   });
//   return { maxX, maxY, minX, minY };
// };
